<template>
<el-container class="hotellist-main" id="main">
  <publicHeader @hotelDetailCurrency="hotelDetailCurrency" @getPermissions="getPermissions" ></publicHeader>
  <div class="main-content">
    <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
    <div class="content" ref="contentWidth">
      <slot>
        <el-main>
          <div class="main">
            <publicSearchCond :key="timer" ref="childCond" :regionSelData="regionSelDetail" :hotelFirstData="hotelFirstData" :hotelRoomSearchFixed="hotelRoomSearchFixed" :hotelRoomSearchFixedPlaceholder="hotelRoomSearchFixedPlaceholder" :personWidth="personWidth" @getSearchInfo="getSearchInfo" @getSearchDate="getSearchDate" :allPermissions="allPermissions"></publicSearchCond>
            <!--搜索结果 开始 :class="{'content-position': rightPosition === true}"  :class="{'list-position': rightPosition === true}"-->
            <div class="list-content">
              <!--细致搜索 开始-->
              <div class="list-search-all">
                  <!--左侧筛选 开始-->
                  <div class="list-left" :style="hotelLeftSearchFixedPlaceholder" ref="listleft">
                    <el-input :placeholder="$t('searchByProperty')" v-model="keyword" style=" width: 204px;height: 40px; margin-left: 13px; margin-top: 20px;" @keyup.enter.native="handleKeyUp">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <div class="starsearch" :style="{ 'margin-left': `${searchLeftWidth}px`}">
                      <div>{{$t('propertyClass')}}</div>
                      <div class="starlevel">
                        <el-checkbox-group v-model="checkedLevel" @change="handlecheckedLevelChange">
                            <div>
                                <el-checkbox :id="key" v-for="(level, key) in levels" :label="key" :key="level">
                                    <span v-html="propertyClassLanguage(key)"></span>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="starsearch" :style="{ 'margin-left': `${searchLeftWidth}px`}" style="margin-bottom: 30px;">
                      <div>{{$t('pricePerNight')}}</div>
                      <div class="starlevel">
                        <el-checkbox-group v-model="checkedBudget" @change="handleCheckedBudgetChange">
                            <div><el-checkbox v-for="(budget, key) in budgets" :label="key" :key="budget" :disabled="budgetNo[key]">{{budget}}</el-checkbox></div>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                  <!--左侧筛选 结束-->
                  <!--右侧展示 开始-->
                  <div class="list-right" id="right" :style="[heightCss, hoteRightSearchFixedPlaceholder]">
                    <!-- <div class="tagAll" style="min-height: 55px;line-height: 55px;">
                      <div id="select-cond" style="display:inline-block;margin-bottom: 1px;" v-for="cond in selectConds" :key="cond">
                        <div class="el-tag el-tag--light">
                          <span v-if="language === 'zh'">
                            <b v-if="oldBudgetsRev[cond] !== '' && oldBudgetsRev[cond] !== undefined">{{budgets[oldBudgetsRev[cond]]}}</b>
                            <b v-else>{{cond}}</b>
                          </span>
                          <span v-else>
                            <b v-if="levelText[cond] !== '' && levelText[cond] !== undefined">{{levelTextEn[levelText[cond]]}}</b>
                            <b v-else-if="oldBudgetsRev[cond] !== '' && oldBudgetsRev[cond] !== undefined">
                              {{budgets[oldBudgetsRev[cond]]}}
                            </b>
                            <b v-else>{{cond}}</b>
                          </span>
                          <img @click="tagClose(cond)" class="imgclose" src="/static/img/hotelsearch/no.png">
                        </div>
                      </div>
                      <div class="closeAll" @click="closeAll">{{$t('deleteFilter')}} <span class="condNum">{{condNum}}</span> {{$t('filters')}}</div>
                    </div> -->
                    <div class="list-info-content" style="margin-top: 15px;">
                      <div class="top">
                        <div id="tab-0" class="istop-0" @click="clickistop('hot', $t('bestMatch'))" :class="{'istop-select-0':istop0}">{{$t('bestMatch')}}</div>
                        <div id="tab-1" class="istop-1" @click="clickistop('low', $t('lowPriceFirst'))" :class="{'istop-select-1':istop1}">{{$t('lowPriceFirst')}}</div>
                        <div id="tab-2" class="istop-2" @click="clickistop('high', $t('highPropertyClass'))" :class="{'istop-select-2':istop2}">{{$t('highPropertyClass')}}</div>
                      </div>
                      <!-- 列表内容 开始 -->
                      <div style="margin-top: 15px;">
                        <div class="hotellist" v-show="!cotentEmptyShow">
                          <div style="width: 54%;">Name</div>
                          <div style="width: 12%;">Star rating</div>
                          <div style="width: 15%; text-align: right;">Total price</div>
                          <div style="width: 19%;"></div>
                        </div>
                        <el-skeleton :count="12" animated :loading="cotentShow">
                          <template slot="template">
                            <div style="border-bottom: 1px solid #d2cfcf; height: 80px; clear: both;">
                              <div style="width: 54%; float: left;">
                                <span style=" font-weight: 650; line-height: 55px;"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                                <span style="font-size: 12px; display: block; height: 30px;">
                                  <el-skeleton-item variant="text" style="width: 90%;" />
                                </span>
                              </div>
                              <div style="width: 12%; line-height: 80px;font-size: 12px; float: left;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                              <div style="width: 13%; line-height: 80px;font-size: 12px; float:left; text-align: right;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                              <div style="width: 21%; float: left; line-height: 80px; text-align: center;">
                                <el-skeleton-item variant="text" style="width: 100px;" />
                              </div>
                            </div>
                          </template>
                          <template>
                            <el-card :body-style="{ padding: '0px' }" v-show="!cotentEmptyShow">
                              <div class="hotel-info" v-for="value in listInfo" :key="value.hotelid">
                                <div style="width: 53%;padding-right: 1%;height: 50px;margin: 12.5px 0;">
                                  <span class="hotelname-text">{{value.hotelname}}</span>
                                  <span style="font-size: 12px; display: block; line-height: 20px; overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">
                                    <img src="/static/img/location.png" style="height: 15px; width: 15px; vertical-align: sub;">
                                      {{value.hoteladdress}}
                                  </span>
                                </div>
                                <div style="width: 12%; line-height: 80px;" v-if="value.star !== 0">
                                  <b style="margin-right: 3px;" v-for="val in value.star" :key="val">
                                    <img style="width:15px;height:15px;" src="/static/img/star.png">
                                  </b>
                                  <b style="margin-left: -3px;" v-if="value.star_decimal === 1">
                                    <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                                  </b>
                                </div>
                                <div style="width: 12%; line-height: 80px; height:80px;" v-else></div>
                                <!-- 积分 -->
                                <div style="width: 15%; line-height: 80px;font-size: 14px; height:80px; text-align: right;" v-if="value.price !== 0 && value.price !== '0'">
                                  <span class="listCurrency-info">{{listCurrency}}</span><span class="price-list-info">{{value.price}}</span>
                                  <span class="point-info" v-if="value.points && value.points !== '0' && value.points !== 0">(+{{Number(value.points).toLocaleString()}} Point)</span>
                                </div>
                                <div style="width: 15%; line-height: 80px;font-size: 14px; height:80px;" v-else>
                                  <span class="price-list-info"></span>
                                </div>
                                <div style="width: 19%;">
                                  <button type="button" style=" margin-top: 20px; float: right;" class="white_button" @click="gotoDetail(value.hotelid, value.name, start_date, end_date, roomNum, adultNum, childNum)" v-if="value.price !== 0 && value.price !== '0'">Book now</button>
                                  <button type="button" style=" margin-top: 20px;" class="booknow_button_disable" @click="gotoDetail(value.hotelid, value.name, start_date, end_date, roomNum, adultNum, childNum)" v-else>Sold out</button>
                                </div>
                              </div>
                              <!--分页 开始-->
                              <div class="hotelpages" :style="pageStyle">
                                <div class="hotel-totaltext">{{city}}：<span v-if="language === 'zh'">共</span> <span class="hotelnum">{{listTotalAll}}</span> {{$t('properties')}}</div>
                                <div class="pageinfo">
                                  <div class="account-data-page">
                                    <el-pagination background :page-size="pageSize"  @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage" > </el-pagination>
                                  </div>
                                </div>
                              </div>
                              <!--分页 结束-->
                            </el-card>
                            <el-card :body-style="{ padding: '0px' }" style="width: 100%; text-align: center;" v-show="cotentEmptyShow">
                              <img src="/static/img/account/empty.png" style="width: 160px; height: 160px; margin-top: 80px;opacity: 0.25;">
                              <div class="empty-txt">We couldn't find any results that match your search criteria. Please modify your search and try again.</div>
                            </el-card>
                          </template>
                        </el-skeleton>
                      </div>
                      <!-- 列表内容 结束 -->
                    </div>
                  </div>
                  <!--右侧展示 结束-->
              </div>
              <!--细致搜索 结束-->
            </div>
            <!--搜索结果 结束-->
          </div>
        </el-main>
      </slot>
      <publicFooter :source="source"></publicFooter>
    </div>
  </div>
  <HotelSearchCond :hotelSearchStar="hotelSearchStar" :budgets="budgets" ref="child" @getSearchStar="getSearchStar" @closepop="closepopEven"></HotelSearchCond>
<!--  <FrameQuotation :frameQuotationDialog="frameQuotationDialog"></FrameQuotation>-->
  <publicMask :fullscreenLoading="frameQuotationDialog"></publicMask>
</el-container>
</template>

<script>
import { hotelList } from '@/request/hotel.js'
import { doCollect } from '@/request/collect.js'
import { getCityInfo } from '@/request/city.js'
import { hotelCurrency } from '@/request/currency.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import publicSearchCond from '@/components/public/publicSearchCond'
import HotelSearchCond from '@/components/hotelsearch/HotelSearchCond'
import FrameQuotation from '@/components/public/frameQuotation.vue'
import publicMask from '@/components/public/publicMask'
const childSelected = {'0': 'selectedone'}
export default {
  name: 'HotelList',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    publicSearchCond,
    HotelSearchCond,
    FrameQuotation,
    publicMask
  },
  data () {
    return {
      hotelSearchStar: false,
      listInfo: [],
      noListInfo: [],
      cotentShow: true,
      cotentEmptyShow: false,
      input_region: '',
      input_date: {},
      input_person: '',
      activeIndex: 0,
      condNum: 0,
      checkedLevel: [],
      levels: this.common.levelOptions,
      checkedBudget: [],
      budgets: {},
      budgetRev: {},
      oldBudgetsRev: {},
      budgetSelectIds: [],
      budgetNo: {5: false, 6: false, 7: false, 8: false, 9: false},
      inputVisible: false,
      inputValue: '',
      selectConds: [],
      selectLevelConds: [],
      selectBudgetConds: [],
      levelText: this.common.levelOptionsRev,
      levelTextEn: this.common.levelOptionsEn,
      budgetText: ['< CNY 500', 'CNY 500 - 1000', 'CNY 1000 - 1500', 'CNY 1500 - 2500', '> CNY 2500'],
      showFilter: false,
      showSort: false,
      istop0: true,
      istop1: false,
      istop2: false,
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      personInfo: '2',
      roomInfo: '1',
      num: 1,
      showPersonInfo: false,
      roomLessDo: false,
      roomAddNoDo: false,
      adultLessDo: false,
      childLessDo: false,
      childAddNoDo: false,
      showChildInfo: false,
      childOld: this.common.childOld,
      childSelected: childSelected,
      selected: '',
      selecteds: [],
      hotelType: 'hot',
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      listTotalAll: 0, // 总条数-完全匹配酒店+附近三家+重点酒店+其他酒店
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      allPersonNum: 2,
      sortvalue: '',
      regionval: '',
      publicRegion: '',
      state: this.common.defaultRegion,
      region_select: this.common.defaultRegionId,
      country: '',
      city: '',
      cityid: 0,
      countryid: 0,
      start_date: '',
      end_date: '',
      region_type: this.common.defaultRegionType, // 目的地类型
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      listCurrency: 'CNY',
      keyword: '',
      frameQuotationDialog: false,
      search_json: {},
      keyword_json: {},
      searchTopping: '',
      hotelRoomSearchFixed: '',
      hotelRoomSearchFixedPlaceholder: '',
      hotelLeftSearchFixedPlaceholder: '',
      hoteRightSearchFixedPlaceholder: '',
      timer: '',
      cityData: {},
      viewSort: false,
      viewSortShowClose: false,
      sortTextzh: {'hot': '：热门推荐', 'low': '：低价优先', 'high': '：高星优先'},
      sortTexten: {'hot': ': Best match', 'low': ': Low price first', 'high': ': High property class'},
      sortText: '',
      ismobile: false,
      regionSelDetail: {},
      hotelFirstData: {},
      mainMinHeight: document.documentElement.clientHeight - 190,
      listMaxCount: Math.floor((document.documentElement.clientHeight - 440) / 80),
      pageStyle: {},
      mainWidth: document.documentElement.clientWidth - 369,
      heightCss: {'min-height': '500px', 'width': '1000px'},
      mustTotal: 0,
      setCurrency: '',
      isCollapse: this.common.collapseSet(this),
      contentWidth: '',
      screenWidth: null,
      personWidth: (document.body.clientWidth - 64) * 0.2182 - 10,
      searchLeftWidth: (document.body.clientWidth - 64) * 0.01,
      source: '',
      rightPosition: false,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      nationality: '',
      is_pkg: 0
    }
  },
  created () {
    if (this.$route.query.is_pkg === 1 || this.$route.query.is_pkg === '1') {
      sessionStorage.setItem('searchAgreementChange', 1)
    } else {
      sessionStorage.removeItem('searchAgreementChange')
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    let leftHeight = document.documentElement.clientHeight - 195
    this.hotelLeftSearchFixedPlaceholder = {'min-height': leftHeight + 'px'}
    this.contentWidth = this.$refs['contentWidth'].clientWidth
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth <= 1500) {
      this.screenWidth = 1500
    }
    this.heightCss = {'min-height': this.mainMinHeight + 'px', 'width': this.mainWidth + 'px'}
    var path = this.$route.path
    if (path.indexOf('HotelList') !== -1) {
      this.isBookActive = true
    } else {
      this.isBookActive = false
    }
    var platfromParam = {
      'sky_fclid': this.$route.query.fclid
    }
    sessionStorage.setItem('platfromParam', JSON.stringify(platfromParam))

    var searchAgreementChange = sessionStorage.getItem('searchAgreementChange')
    if (searchAgreementChange !== undefined && (searchAgreementChange === 1 || searchAgreementChange === '1')) {
      this.is_pkg = 1
    }

    let contentwidthinfo = document.body.clientWidth
    if (contentwidthinfo < 1500) {
      contentwidthinfo = 1500
    }
    if (this.isCollapse === false) {
      this.contentWidth = contentwidthinfo - 215
    } else {
      this.contentWidth = contentwidthinfo - 64
    }
    this.personWidth = (this.contentWidth * 0.2182) - 10
    this.searchLeftWidth = this.contentWidth * 0.01
    var language = this.$route.query.language
    if (language !== '' && language !== undefined && language !== null) {
      this.language = language
    }
    this.currency = this.common.currencySet(this)
    var currency = this.$route.query.currency
    if (currency !== '' && currency !== undefined && currency !== null) {
      this.currency = currency
    }
    var queryNationality = this.$route.query.nationality
    if (queryNationality !== '' && queryNationality !== undefined && queryNationality !== null) {
      this.nationality = queryNationality
    }
    // 存储来源
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // var restaurantsJson = localStorage.getItem('restaurants')
    // var restaurantsArr = JSON.parse(restaurantsJson)
    // 提供给头部展示名称
    var regionSelJson = sessionStorage.getItem('regionSel')
    this.regionSelDetail = JSON.parse(regionSelJson)
    var regionselect = this.$route.query.type_id
    if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
      this.region_select = regionselect
    } else if (this.regionSelDetail !== null) {
      this.region_type = this.regionSelDetail.type_data_id
    }

    var regiontype = this.$route.query.type
    if (regiontype !== undefined && regiontype !== null && regiontype !== '' && !isNaN(regiontype)) {
      this.region_type = regiontype
    } else if (this.regionSelDetail !== null) {
      this.region_type = this.regionSelDetail.type_id
    }
    let state = this.$route.query.region
    this.state = state
    // default value
    let regionSel = sessionStorage.getItem('regionSel')
    if (regionSel === null || regionSel === undefined || regionSel === '') {
      let regionSel = {'value_zh': this.common.defaultRegion, 'value_en': this.common.defaultRegion, 'type_id': this.common.defaultRegionType, 'type_data_id': this.common.defaultRegionId}
      if (state !== undefined && state !== null && state !== '') {
        regionSel = {'value_zh': state, 'value_en': state, 'type_id': regiontype, 'type_data_id': regionselect}
      } else {
        this.state = this.common.defaultRegion
      }
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
    }

    this.start_date = this.$route.query.start_date
    this.end_date = this.$route.query.end_date
    var room = this.$route.query.room
    if (room !== undefined && room !== null && room !== '' && !isNaN(room)) {
      this.roomNum = room
    }
    var adult = this.$route.query.adult
    if (adult !== undefined && adult !== null && adult !== '' && !isNaN(adult)) {
      this.adultNum = adult
    }
    var child = this.$route.query.child
    if (child !== undefined && child !== null && child !== '' && !isNaN(child)) {
      this.childNum = child
    }
    var childNums = this.$route.query.childNums
    if (this.childNum !== undefined && this.childNum !== null && this.childNum !== '' && this.childNum > 0 && !isNaN(this.childNum)) {
      this.selecteds = []
      this.selecteds = childNums
    }
    // // 默认列表-热门推荐
    var hotelType = this.$route.query.hotelType
    if (hotelType !== undefined && hotelType !== null && hotelType !== '') {
      this.hotelType = hotelType
      if (hotelType === 'low') {
        this.istop0 = false
        this.istop1 = true
        this.istop2 = false
      } else if (hotelType === 'high') {
        this.istop0 = false
        this.istop1 = false
        this.istop2 = true
      }
    }
    // keyword
    var keyword = this.$route.query.keyword
    if (keyword !== undefined && keyword !== null && keyword !== '') {
      this.keyword = keyword
    }
    this.getCurrencyList()
    this.refreshParams()
    this.getCity()
    // 下滑搜索条置顶
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.name = ''
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        let allwidth = document.documentElement.clientWidth
        if (allwidth <= 1500) {
          allwidth = 1500
        }
        this.mainWidth = allwidth - 369
        this.heightCss = {'min-height': this.mainMinHeight + 'px', 'width': this.mainWidth + 'px'}
        this.contentWidth = this.$refs['contentWidth'].clientWidth

        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 60) {
          let width = this.contentWidth - 30
          this.hotelRoomSearchFixed = {'width': width + 'px', 'position': 'fixed', 'top': '0px', 'z-index': 1999, 'margin': '0px auto'}
        } else {
          this.hotelRoomSearchFixed = ''
        }
      }
    },
    currency: function (newCur, oldCur) {
      this.getCurrencyList()
      this.getCity()
      this.getList(this.currentPage)
    },
    language: function (newCur, oldCur) {
      this.getCity()
      this.getList(this.currentPage)
      this.language = newCur
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.fromPath = from.path
      var fromname = from.name
      if (fromname !== null) {
        localStorage.setItem('keyword', JSON.stringify({}))
        localStorage.setItem('star', JSON.stringify([]))
        var budgetInfo = {'budget': [], 'budgetSelect': [], 'budgetSelectIds': []}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        localStorage.setItem('type', 'hot')
        localStorage.setItem('showSort', false)
        localStorage.setItem('showFilter', false)
      }
    })
  },
  methods: {
    handleResize () {
      this.screenWidth = document.body.clientWidth
      if (this.screenWidth <= 1500) {
        this.screenWidth = 1500
      }
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    hotelLanguage (language) {
      this.language = language
    },
    // 下拉置顶
    handleScroll: function () {
      let leftHeight = document.documentElement.clientHeight - 195
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 60) {
        let leftWidth = this.$refs['listleft'].clientWidth
        let width = this.contentWidth - 30
        this.hotelRoomSearchFixed = {'width': width + 'px', 'position': 'fixed', 'top': '0px', 'z-index': 1999, 'margin': '0px auto'}
        this.hotelRoomSearchFixedPlaceholder = {'display': 'block'}
        this.hotelLeftSearchFixedPlaceholder = {'min-height': leftHeight + 'px', 'display': 'block', 'width': leftWidth + 'px', 'position': 'fixed', 'top': '115px'}
        // this.hoteRightSearchFixedPlaceholder = {'display': 'block', 'position': 'fixed', 'top': '115px', 'left': leftLen + 'px', 'width': rightWidth + 'px', 'overflow-y': 'auto'}
        this.rightPosition = true
      } else {
        this.hotelRoomSearchFixed = ''
        this.hotelRoomSearchFixedPlaceholder = ''
        this.hotelLeftSearchFixedPlaceholder = {'min-height': leftHeight + 'px'}
        this.hoteRightSearchFixedPlaceholder = ''
        this.rightPosition = false
      }
    },
    refreshParams () {
      var star = localStorage.getItem('star')
      if (star !== null && star !== '') {
        this.checkedLevel = JSON.parse(star)
        this.checkedLevel.forEach((item, index) => {
          this.selectLevelConds.push(this.common.levelOptions[ item ])
        })
        this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
        this.condNum = this.selectConds.length
      }
      var budgetInfo = localStorage.getItem('budgetInfo')
      if (budgetInfo !== null && budgetInfo !== '') {
        var budgetArr = JSON.parse(budgetInfo)
        var budget = budgetArr['budget']
        this.checkedBudget = budget
        this.selectBudgetConds = budgetArr['budgetSelect']
        this.budgetSelectIds = budgetArr['budgetSelectIds']
        this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
        this.condNum = this.selectConds.length
        if (this.checkedBudget.length > 1) {
          budget.sort()
          var num = parseInt(budget[ budget.length - 1 ]) - parseInt(budget[ 0 ])
          if (num > 1) {
            var i
            for (i = 1; i < num; i++) {
              var id = parseInt(budget[ 0 ]) + i
              this.budgetNo[ id ] = true
            }
          }
        }
      }
      // var page = localStorage.getItem('page')
      // if (page !== null && page !== '') {
      //   this.currentPage = parseInt(page)
      //   if (this.currentPage > 1) {
      //     var nolist = localStorage.getItem('noListInfo')
      //     if (nolist !== {} && nolist !== '') {
      //       this.noListInfo = JSON.parse(nolist)
      //     }
      //     var total = localStorage.getItem('total')
      //     if (total !== {} && total !== '' && total !== 0) {
      //       this.listTotal = parseInt(total)
      //     }
      //   }
      // }
      var showFilter = localStorage.getItem('showFilter')
      if (showFilter !== null && showFilter !== '') {
        this.showFilter = showFilter
      }
    },
    handlecheckedLevelChange (value) {
      let surplusLevelSelectConds = []
      if (this.selectLevelConds.length < value.length) {
        // 选择星级操作记录埋点
        // this.clickPageAction('star_filter', this.common.levelOptions[ value[ value.length - 1 ] ], {'type': 'add'})

        this.selectLevelConds.push(this.common.levelOptions[ value[ value.length - 1 ] ])
      } else {
        value.forEach((item, index) => {
          surplusLevelSelectConds.push(this.common.levelOptions[item])
        })
        if (surplusLevelSelectConds === '' || surplusLevelSelectConds === null) {
          this.selectLevelConds = []
        } else {
          this.selectLevelConds.forEach((item, index) => {
            if (!surplusLevelSelectConds.includes(item)) {
              // 选择星级操作记录埋点
              // this.clickPageAction('star_filter', item, {'type': 'less'})

              this.selectLevelConds.splice(this.selectLevelConds.indexOf(item), 1)
            }
          })
        }
      }
      this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
      this.condNum = this.selectConds.length
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))

      // 选择星级操作记录埋点
      var selectStar = []
      this.selectLevelConds.forEach((item, index) => {
        selectStar.push(item.split('/')['0'])
      })
      this.clickPageAction('star_filter', '', selectStar)
      this.getList(1)
    },
    handleCheckedBudgetChange (value) {
      let surplusBudgetSelectConds = []
      // 勾选
      if (this.budgetSelectIds.length < value.length) {
        // 选择价格操作记录埋点
        this.clickPageAction('price_filter', this.budgets[ value[ value.length - 1 ] ], {'type': 'add'})

        this.selectBudgetConds.push(this.budgets[ value[ value.length - 1 ] ])
        this.budgetSelectIds.push(value[ value.length - 1 ])
        if (value.length > 1) {
          value.sort()
          var num = parseInt(value[ value.length - 1 ]) - parseInt(value[ 0 ])
          if (num > 1) {
            var i
            for (i = 1; i < num; i++) {
              var id = parseInt(value[ 0 ]) + i
              this.budgetSelectIds.push(id.toString())
              this.budgetNo[ id ] = true
              this.checkedBudget.push(id.toString())
              if (this.selectBudgetConds.includes(this.budgets[ id ])) {
                this.selectBudgetConds.splice(this.selectConds.indexOf(this.budgets[ id ]), 1)
              }
            }
          }
        }
      } else {
        value.forEach((item, index) => {
          surplusBudgetSelectConds.push(this.budgets[ item ])
        })

        // 取消勾选后，没有任何勾选
        if (surplusBudgetSelectConds === '' || surplusBudgetSelectConds === null || surplusBudgetSelectConds.length === 0) {
          this.selectBudgetConds.forEach((item, index) => {
            // 选择价格操作记录埋点
            this.clickPageAction('price_filter', item, {'type': 'less'})
          })

          this.selectBudgetConds = []
          this.checkedBudget = []
          this.budgetSelectIds = []
        } else {
          // 取消勾选后，还有其他勾选
          this.selectBudgetConds.forEach((item, index) => {
            if (!surplusBudgetSelectConds.includes(item)) {
              // 选择价格操作记录埋点
              this.clickPageAction('price_filter', item, {'type': 'less'})

              var cancelid = this.budgetsRev[ item ]
              this.budgetSelectIds.sort()
              var min = this.budgetSelectIds[ 0 ]
              var max = this.budgetSelectIds[ this.budgetSelectIds.length - 1 ]
              // 如果取消的是最小值，则只保留最大值
              if (parseInt(cancelid) === parseInt(min)) {
                // 取最大值
                this.selectBudgetConds = [ this.budgets[ max ] ]
                this.checkedBudget = [ max.toString() ]
                this.budgetSelectIds = [ max.toString() ]
              } else {
                // 如果取消的是最大值，则只保留最小值
                this.selectBudgetConds = [ this.budgets[ min ] ]
                this.checkedBudget = [ min.toString() ]
                this.budgetSelectIds = [ min.toString() ]
              }
              this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
            }
          })
        }
      }
      this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
      this.condNum = this.selectConds.length
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      this.getList(1)
    },
    tagClose (tag) {
      if (this.selectLevelConds.includes(tag)) {
        this.selectLevelConds.splice(this.selectConds.indexOf(tag), 1)
        this.checkedLevel.splice(this.checkedLevel.indexOf(this.common.levelOptionsRev[tag]), 1)

        // 埋点
        var selectStar = []
        this.selectLevelConds.forEach((item, index) => {
          selectStar.push(item.split('/')['0'])
        })
        this.clickPageAction('star_type', tag, selectStar)
      }
      if (this.selectBudgetConds.includes(tag)) {
        // 点击排序埋点记录
        this.clickPageAction('price_type', tag, {'type': 'less', 'palace': 'top'})

        this.selectBudgetConds.splice(this.selectConds.indexOf(tag), 1)
        if (this.selectBudgetConds.length > 0) {
          // 如果删除后，还有 其他价格范围已勾选
          var id = this.budgetsRev[ this.selectBudgetConds[ 0 ] ]
          this.checkedBudget = [ id.toString() ]
          this.budgetSelectIds = [ id ]
        } else {
          // 如果删除后，没有 其他价格范围已勾选
          this.selectBudgetConds = []
          this.checkedBudget = []
          this.budgetSelectIds = []
        }
      }
      this.selectConds.splice(this.selectConds.indexOf(tag), 1)
      this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      this.condNum -= 1
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      this.getList(1)
    },
    closeAll () {
      // 点击排序埋点记录
      this.clickPageAction('price_type', 'close-all', {'type': 'less', 'palace': 'top'})

      if (this.condNum > 0) {
        this.selectConds = []
        this.checkedLevel = []
        this.checkedBudget = []
        this.selectLevelConds = []
        this.selectBudgetConds = []
        this.budgetSelectIds = []
        this.condNum = 0
        this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
        localStorage.setItem('star', JSON.stringify(this.checkedLevel))
        var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        this.getList(1)
      }
    },
    // hot：热门推荐 low：价低优先 high：高星优先
    clickistop (type, title) {
      // 点击排序埋点记录
      this.clickPageAction('price_type', type, {'sort': type})

      this.hotelType = type
      if (type === 'hot') {
        this.istop0 = true
        this.istop1 = false
        this.istop2 = false
      } else if (type === 'low') {
        this.istop0 = false
        this.istop1 = true
        this.istop2 = false
      } else if (type === 'high') {
        this.istop0 = false
        this.istop1 = false
        this.istop2 = true
      }
      var query = JSON.parse(JSON.stringify(this.$route.query))
      query.hotelType = this.hotelType
      this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: query})
      localStorage.setItem('type', type)
      this.showSort = true
      localStorage.setItem('showSort', this.showSort)
      this.viewSort = false
      // if (this.condNum > 0) {
      //   this.selectConds = []
      //   this.checkedLevel = []
      //   this.checkedBudget = []
      //   this.selectLevelConds = []
      //   this.selectBudgetConds = []
      //   this.budgetSelectIds = []
      //   this.condNum = 0
      //   this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      //   localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      //   var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      //   localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      // }
      this.getList(1)
    },
    roomAdd () {
      if (this.roomNum < 10) {
        this.roomNum += 1
        this.roomLessDo = true
        this.roomInfo = this.roomNum + '间客房'
        if (this.roomNum > this.adultNum) {
          this.adultNum = this.roomNum
          this.adultLessDo = true
          this.personInfo = this.adultNum + '名大人'
        }
      } else {
        this.roomAddNoDo = true
      }
    },
    roomLess () {
      if (this.roomNum > 1) {
        this.roomNum -= 1
        if (this.roomNum === 1) {
          this.roomLessDo = false
        }
        this.roomInfo = this.roomNum + '间客房'
      }
      if (this.roomNum < 10) {
        this.roomAddNoDo = false
      }
    },
    adultAdd () {
      this.adultNum += 1
      this.adultLessDo = true
      this.personInfo = this.adultNum + '名大人'
    },
    adultLess () {
      if (this.adultNum > 1) {
        this.adultNum -= 1
        if (this.adultNum === 1) {
          this.adultLessDo = false
        }
        this.personInfo = this.adultNum + '名大人'
        if (this.roomNum > this.adultNum) {
          this.roomNum = this.adultNum
          this.roomInfo = this.roomNum + '间客房'
          if (this.roomNum === 1) {
            this.roomLessDo = false
          }
          if (this.roomNum < 10) {
            this.roomAddNoDo = false
          }
        }
      }
    },
    childAdd () {
      if (this.childNum < 10) {
        this.childNum += 1
        this.childLessDo = true
        this.personInfo = this.adultNum + '名大人,' + this.childNum + '名儿童'
      } else {
        this.childAddNoDo = true
      }
      if (this.childNum === 1) {
        this.showChildInfo = true
      }
    },
    childLess () {
      if (this.childNum > 0) {
        this.childNum -= 1
        this.personInfo = this.adultNum + '名大人,' + this.childNum + '名儿童'
        if (this.childNum === 0) {
          this.childLessDo = false
          this.personInfo = this.adultNum + '名大人'
        }
      }
      if (this.roomNum < 10) {
        this.childAddNoDo = false
      }
      if (this.childNum === 0) {
        this.showChildInfo = false
      }
    },
    showPerson () {
      if (this.showPersonInfo === false) {
        this.showPersonInfo = true
      } else {
        this.showPersonInfo = false
      }
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.start = (val - 1) * this.pageSize // （val-1）是我自己的项目需要，一般写val即可
      localStorage.setItem('page', val)
      this.getList(val)
    },
    getCity () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'region_type': this.region_type,
        'region': this.region_select,
        'time': time,
        'language': this.language,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getCityInfo(data).then(res => {
        if (res.flag === '200') {
          this.country = res.data.countryname
          this.city = res.data.cityname
          this.countryid = res.data.country_id
          this.cityid = res.data.city_id
          this.cityData = {
            'city_type_id': res.data.city_type_id,
            'city_type_en': res.data.city_type_en,
            'city_type_zh': res.data.city_type_zh
          }
        }
      })
    },
    getList (page) {
      document.querySelector('#main').scrollIntoView({
        behavior: 'smooth'
      })
      this.listInfo = []
      this.cotentShow = true
      this.stopScroll()
      // hot：热门推荐 low：价低优先 high：高星优先
      // const loading = this.$loading({
      //   lock: true,
      //   text: '酒店加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })

      if (this.start_date === this.end_date) {
        var endDate = new Date(this.start_date)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        this.end_date = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }

      // 被搜索到的酒店
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      // var sessionid = this.common.sessionidGet(this)
      if (page === 1 || page === '1') {
        this.mustTotal = 0
      }

      var regionSelJson = sessionStorage.getItem('regionSel')
      var region = this.state
      if (regionSelJson !== undefined && regionSelJson !== null) {
        var regionSelArr = JSON.parse(regionSelJson)

        region = regionSelArr.value_en
      }

      if (region === undefined) {
        region = ''
      }
      var dataJson = {
        'region_keyword': region,
        'keyword': this.keyword,
        'type': this.hotelType,
        'region_type': this.region_type,
        'region': this.region_select,
        'start_date': this.start_date,
        'end_date': this.end_date,
        'room': this.roomNum,
        'adult': this.adultNum,
        'child': this.childNum,
        'childNums': this.selecteds,
        'star': this.checkedLevel,
        'budget': this.checkedBudget,
        'page': page,
        'time': time,
        'language': this.language,
        'currency': this.currency,
        'source': this.source,
        'token': token,
        'mustcount': this.mustTotal,
        'nationality': this.nationality,
        'is_pkg': this.is_pkg
      }
      if (page > 1) {
        dataJson['nolist'] = this.noListInfo
        dataJson['mustcount'] = this.mustTotal
      }
      var regionSel = {'value_zh': region, 'value_en': region, 'type_id': this.region_type, 'type_data_id': this.region_select}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var data = this.common.encryptionData(dataJson, this)
      hotelList(data).then(res => {
        if (res.flag === '110') {
          // 无权限
          location.reload()
        } else if (res.flag === '200' || res.flag === '201') {
          this.listInfo = res.data.hotellist
          this.noListInfo = res.data.nohotellist
          this.listCurrency = res.data.currency
          localStorage.setItem('noListInfo', JSON.stringify(this.noListInfo))
          this.listTotal = parseInt(res.data.totalNum)
          localStorage.setItem('total', this.listTotal)
          this.listTotalAll = parseInt(res.data.totalNumAll)
          if (this.listTotalAll <= this.listMaxCount) {
            var top = 130 + ((this.listMaxCount - this.listTotalAll - 1) * 80)
            this.pageStyle = {'margin-top': top + 'px'}
          } else {
            this.pageStyle = {}
          }
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.cotentShow = false
          this.cotentEmptyShow = false
          this.mustTotal = parseInt(res.data.mustcount)
        } else if (res.flag === '112') {
          this.cotentShow = false
          this.cotentEmptyShow = true
        } else {
          this.cotentShow = false
          this.cotentEmptyShow = true
        }
        this.canScroll()
        // loading.close()
        this.frameQuotationDialog = false

        return res
      }).then(res => {
        if (this.listInfo.length !== '0' && this.listInfo[0].ismatch === true) {
          this.hotelFirstData = this.listInfo[0]
        }

        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    querySearch (queryString, cb) {
      cb(this.restaurants)
    },
    handleSelect (item) {
      this.region_select = item.id
    },
    closepopEven: function (type) {
      if (type === 'hotelSearchStar') {
        this.hotelSearchStar = false
      }
    },
    getSearchInfo (val) {
      this.is_pkg = val['is_pkg']
      this.region_select = val['type_id']
      this.region_type = val['type']
      this.start_date = val['start_date']
      this.end_date = val['end_date']
      this.roomNum = val['room']
      this.adultNum = val['adult']
      this.childNum = val['child']
      this.state = val['region']
      this.selecteds = val['childNums']
      this.nationality = val['nationality']
      this.keyword = ''
      this.search_json['region'] = val['region']
      this.search_json['type'] = val['type']
      this.search_json['type_id'] = val['type_id']
      this.search_json['start_date'] = val['start_date']
      this.search_json['end_date'] = val['end_date']
      this.search_json['room'] = this.roomNum
      this.search_json['adult'] = this.adultNum
      this.search_json['child'] = this.childNum
      this.search_json['childNums'] = this.selecteds
      this.search_json['nationality'] = this.nationality
      this.search_json['is_pkg'] = val['is_pkg']
      localStorage.setItem('searchData', JSON.stringify(this.search_json))
      this.keyword_json['keyword'] = this.keyword
      this.keyword_json['cityid'] = 0
      this.keyword_json['countryid'] = 0
      localStorage.setItem('keyword', JSON.stringify(this.keyword_json))
      var dates = {'startdate': this.start_date, 'enddate': this.end_date}
      localStorage.setItem('noListInfo', JSON.stringify({}))
      localStorage.setItem('total', 0)
      this.selectConds = []
      this.checkedLevel = []
      this.checkedBudget = []
      this.selectLevelConds = []
      this.selectBudgetConds = []
      this.budgetSelectIds = []
      this.condNum = 0
      this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      localStorage.setItem('dates', dates)
      localStorage.setItem('page', 1)
      localStorage.setItem('showFilter', false)
      localStorage.setItem('showSort', false)
      this.getCity()
      this.frameQuotationDialog = true
      this.currency = this.common.currencySet(this)
      var query = JSON.parse(JSON.stringify(this.$route.query))
      query.hotelType = ''
      query.keyword = ''
      query.type = val['type']
      query.type_id = val['type_id']
      query.region = val['region']
      query.start_date = val['start_date']
      query.end_date = val['end_date']
      query.room = val['room']
      query.adult = val['adult']
      query.child = val['child']
      query.childNums = val['childNums']
      query.currency = this.currency
      query.nationality = this.nationality
      query.is_pkg = val['is_pkg']
      this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: query})
      this.setCurrency = this.currency
      this.getList(1)
    },
    getSearchDate (val) {
      this.start_date = val['start_date']
      this.end_date = val['end_date']
      var regionSelJson = sessionStorage.getItem('regionSel')
      if (regionSelJson !== '{}' && regionSelJson !== null) {
        var params = JSON.parse(regionSelJson)
        this.region_type = params.type_id
        this.region_select = params.type_data_id
      }
      this.getList(1)
    },
    getSearchStar (val) {
      var level = val['level']
      var budget = val['budget']
      if (level.length > 0 || budget.length > 0) {
        this.showFilter = true
      } else {
        this.showFilter = false
      }
      localStorage.setItem('showFilter', this.showFilter)
      this.checkedLevel = level
      this.checkedBudget = budget
      this.getList(1)
    },
    // closeLevel () {
    //   this.showLevel = false
    //   this.$refs.child.checkedLevel = [] // 修改子组件data
    //   this.checkedLevel = []
    //   this.getList(1)
    // },
    // closeBudget () {
    //   this.showBudget = false
    //   this.$refs.child.checkedBudget = []
    //   var budget = {5: false, 6: false, 7: false, 8: false, 9: false}
    //   this.$refs.child.budgetNo = budget
    //   this.checkedBudget = []
    //   this.budgetNo = budget
    //   this.getList(1)
    // },
    collect (listname, key, hotelid, islike) {
      var dolike = parseInt(islike) === 1 ? 0 : 1
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      this.listInfo[key]['islike'] = dolike
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': hotelid, 'status': dolike, 'token': token, 'time': time, 'language': this.language, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      // 收藏酒店埋点记录
      this.clickPageAction('hotel_collect', '', data)

      doCollect(data).then(res => {
        if (res.flag === '001') {
          this.$router.push({name: 'login'})
        } else if (res.flag === '141') {
          this.remindFaild = true
          this.remindMessage = res.msg
          this.listInfo[key]['islike'] = islike
        }
        return res
      })
    },
    getCurrencyList () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'currency': this.currency, 'language': this.language, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      hotelCurrency(data).then(res => {
        this.budgets = res.budgets
        this.budgetsRev = res.budgetsRev
        this.oldBudgetsRev = res.oldBudgetsRev
        this.$refs.child.budgets = res.budgets
        this.$refs.child.budgetsRev = res.budgetsRev
        this.$refs.child.oldBudgetsRev = res.oldBudgetsRev
      })
    },
    handleKeyUp () {
      this.keyword_json['keyword'] = this.keyword
      // this.keyword_json['cityid'] = this.cityid
      // this.keyword_json['countryid'] = this.countryid
      localStorage.setItem('keyword', JSON.stringify(this.keyword_json))
      var query = JSON.parse(JSON.stringify(this.$route.query))
      query.keyword = this.keyword
      this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: query})
      this.getList(1)
    },
    propertyClassLanguage (key) {
      return this.$t(this.common.propertyLanguage[key])
    },
    gotoDetail (hotelid, name, startdate, enddate, roomNum, adultNum, childNum) {
      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = name
      detailjson['start_date'] = startdate
      detailjson['end_date'] = enddate
      detailjson['room'] = roomNum
      detailjson['adult'] = adultNum
      detailjson['child'] = childNum
      detailjson['currency'] = this.currency
      detailjson['childNums'] = this.selecteds
      detailjson['source'] = this.source
      detailjson['nationality'] = this.nationality
      detailjson['is_pkg'] = this.is_pkg
      // 选择客房操作记录
      this.clickPageAction('select_room', '', detailjson)
      var searchJson = {'type': 1, 'type_id': this.cityData.city_type_id, 'region': this.cityData.city_type_en, 'start_date': this.start_date, 'end_date': this.end_date, 'room': this.roomNum, 'adult': this.adultNum, 'child': this.childNum, 'childNums': this.selecteds, 'nationality': this.nationality, 'is_pkg': this.is_pkg}
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      // this.$router.push({name: 'HotelDetail', query: detailjson})
      let routeData = this.$router.resolve({name: 'HotelDetail', query: detailjson})
      window.open(routeData.href, '_blank')
    },
    focusDate: function (hotelid, hotelData) {
      if (this.common.languageSet(this) === 'zh') {
        this.$refs.childCond.state = hotelData.hotelname_zh
      } else {
        this.$refs.childCond.state = hotelData.hotelname
      }
      this.$refs.childCond.region_select = hotelid
      this.$refs.childCond.region_type = 3

      var regionSel = {'value_zh': hotelData.hotelname_zh, 'value_en': hotelData.hotelname, 'type_id': 3, 'type_data_id': hotelid}
      // 保留选择的目的地
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      // 更改日期操作记录埋点
      this.clickPageAction('hotel_change_date', hotelid, {'hotelid': hotelid})

      if (document.body.clientWidth < 1001) {
        // 尺寸如果低于1001 则触发frame
        this.$refs.childCond.hotelSearchFrame = true
      } else {
        // 尺寸如果高于1001
        this.$refs.childCond.parentFocus()
        document.querySelector('#main').scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    rollToFirst (hotelid) {
      // 查看别的酒店 埋点记录
      this.clickPageAction('change_hotel', hotelid, {'hotelid': hotelid})

      document.querySelector('#right').scrollIntoView({
        behavior: 'smooth'
      })
    },
    stopScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    canScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = ''
      document.addEventListener('touchmove', mo, false)
    }
  }
}
</script>

<style scoped>
.hotellist-main /deep/ .el-header {
  position: absolute;
}
/* 左侧 menu*/
.main{width:100%;}

/* 标题部分 */
.page-title{border:none;background:#F2F2F2; width: 100%; height: 48px; font-size: 16px;font-weight: bolder;line-height: 48px; padding: 0 16px;}
/* 搜索条件 开始 */
.list-content{margin: 0 auto;}
/* 目的地 */
/* .input-region{width: 361px; height: 48px;} */
.hotellist-region /deep/ .el-input__inner{padding: 0 60px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;}
.location-search .hotellist-region{width:35%;}
.el-autocomplete{width:100%;}
/* .el-autocomplete /deep/ .el-input__inner{ font-size: 16px;} */
.hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
.hotellist-region input:focus,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.my-autocomplete .name {height:25px;text-overflow: ellipsis;overflow: hidden;font-weight: 650; color:#4F4C4C;}
.my-autocomplete .addr {height:25px;font-weight: 100;color: #4F4C4C;}
.my-autocomplete .highlighted .addr {color: #ddd;}
/* 日期 */
.hotellist-date{padding: 0px 50px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
.el-range-editor.el-input__inner{display:inline-block;}
.el-date-editor--daterange.el-input__inner{ width:30%;}
.input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 23px;background-position: 0px center;}
.hotellist-date .el-range__icon{margin-left:0px;}
/deep/ .el-date-editor .el-range-separator{display: none;}

/* 入住人 */
.person-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.inphotellistut-person .person-inner:hover{border-color:rgb(252, 210, 5, 1);}
/* .el-select-dropdown{display:none;} */
.personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff;}
.personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
.personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.personnum{position: relative;display: inline-block;width: 224px;line-height: 38px;text-align: center;}
.personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;}
.personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
.personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
.personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
.personnum span{display:inline-block;}
.personnum input{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
.personnum input:focus{border:0;outline:none;width:20px;height:32px;}
.spantext{color:#999999; font-size: 14px;}
.select-person{display:inline-block; width:ffvgg20%;vertical-align: -webkit-baseline-middle;}
.showPersonBorder{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.showPersonBorder:hover{border-color:rgb(252, 210, 5, 1);}
.personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;white-space: nowrap;overflow: hidden;}
.roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;}
.childinfo .el-select-dropdown,.el-select-dropdown{display:block}
.selectOld{width: 40%;float: left;margin-left: 5%; margin-top: -7%;}
/* 加减成人 */
.personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
.personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
/* 入住人选择 */
.personInfo{border-width: 0px;position: absolute;left: 61.2%;width: 224px;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); color: #999999;font-size: 14px;}
/* 搜索 */
.hotellist_button{cursor: pointer; width:12%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
.hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}

/* 导航 */
.directory{height:46px;width:100%;font-size: 12px;text-align: left;line-height: 46px;}
.directory a{text-decoration:none;color: #4F4C4C;}
.slash{color: #C0C4CC;padding:0px 5px 0px 5px;}
/* 细致搜索 */
.list-search-all{height:auto;}
/deep/ .list-search{height: 145px !important;}
.list-left{width:230px;float: left;background: #FFF;border-radius: 5px;border: none;}
/* 左侧搜索 */
/deep/ .el-input.is-active .el-input__inner,/deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);}
.icon-search{background-image: ("https://res.roompai.com/static/img/hotelsearch/4F4C4C.png");width:20px;height: 20px;}
/* .keyword-search img{position: absolute;transform: translateX(-120px);margin-top: 10px;margin-left: 10px;height: 20px;width: 20px;} */
.keyword-search input{height:40px;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/2-4F4C4C.png);background-repeat:no-repeat;background-size: 20px;background-position: 15px center;padding: 0px 50px;width: 95%; font-size: 14px;opacity:1;border:1px solid rgba(221, 223, 226, 1);}

/* 星级筛选 和 您的预算 */
.starsearch{font-size: 14px;float: left;min-height: 200px; margin: 15px 0;}
.starlevel{font-weight: 200;color: #4F4C4C;font-size: 14px;margin-top:5px;display: block;}
.el-checkbox{margin-top:20px;font-weight: 200;display: block;}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color: rgba(83, 102, 163, 1);}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: rgba(83, 102, 163, 1);border-color:rgba(83, 102, 163, 1);}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{border-color:rgba(83, 102, 163, 1);}
/* 右侧结果 */
.list-right{float: right; margin-left: 15px;background: #FFF;border-radius: 5px; padding: 0 15px;}
.list-right .el-tag{margin-left: 10px;background-color: rgba(83, 102, 163, 1);border:none;color: #FFF;height: 32px;padding: 0 10px;line-height: 30px;font-size: 12px;font-weight: 400;border-width: 1px;border-style: solid;border-radius: 39px;-webkit-box-sizing: border-box;box-sizing: border-box;white-space: nowrap;}
.imgclose{width: 12px;height: 12px;padding-left: 4px;margin-bottom: -1px;cursor:pointer;}
.closeAll{font-size: 12px;color: #4F4C4C;cursor: pointer;display: inline-block;}
.closeAll:hover{text-decoration:underline;color:  rgba(83, 102, 163, 1);}
.condNum{font-size: 14px;font-weight: 650;color: rgba(83, 102, 163, 1);}
.content-empty{height: 400px;text-align: center;padding-top: 40px;}
.content /deep/ .el-card{border: none;}
.content /deep/ .el-card.is-always-shadow, .content /deep/ .el-card.is-hover-shadow:focus, .content /deep/ .el-card.is-hover-shadow:hover{box-shadow: none;-webkit-box-shadow:none;}
/* 热门推荐 价低优先 高星优先 */
.tagAll{display:block;}
.top{border: 1px solid rgba(221, 223, 226, 1);box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);border-radius: 4px;width: 100%;height: 40px;font-weight: 650;font-style: normal;font-size: 0;line-height: 40px;text-align: center;}
.istop-0{display: inline-block;border-right: 1px solid rgba(221, 223, 226, 1);width: 34%;height: 40px;box-sizing: border-box;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;cursor: pointer;font-size: 14px;}
.istop-1{display: inline-block;width: 33%;height: 40px;cursor: pointer;font-size: 14px;}
.istop-2{display: inline-block;border-left: 1px solid rgba(221, 223, 226, 1);width: 32.999%;height: 40px;box-sizing: border-box;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;cursor: pointer;font-size: 14px;}
.istop-select-0{border: none; border-radius: 4px;border-top-right-radius: 0px;border-bottom-right-radius: 0px;background-color: rgba(83, 102, 163, 1);color: rgb(255, 255, 255);}
.istop-select-1{background-color: rgba(83, 102, 163, 1);color: #FFF;}
.istop-0:hover,.istop-1:hover,.istop-2:hover{color:rgba(83, 102, 163, 1); }
.istop-select-0:hover,.istop-select-1:hover,.istop-select-2:hover{color: #FFF;}
.istop-select-2{border: none; border-radius: 4px;border-top-left-radius: 0px;border-bottom-left-radius: 0px;background-color:rgba(83, 102, 163, 1);color: #FFF;}
.right-position{ position: absolute;
    top: 80px;
    left: 15%;
    width: 82%;
    max-height: calc(100vh - 100px);
    overflow-y: auto;}
.content-position{position: relative;}
.list-position{position: absolute; top: 105px;}
/* 酒店列表 */
.hotelname-text{font-weight: 650; line-height: 30px; font-size: 14px;}
.list-info-content{ width: 100%;background-color: #FFF;}
/deep/ .el-table th.el-table__cell{background-color: rgba(242, 242, 242, 1); color: #333; font-size: 16px; font-weight: 650;}
.hotelname-info{font-size: 12px;}
.el-table_1_column_1{ width: 40% !important;}
.match-hotel{height: 40px; background: inherit; background-color: rgba(83, 146, 249, 0.9215686274509803); border: none; border-radius: 10px; border-bottom-right-radius: 0px; border-bottom-left-radius: 0px; -moz-box-shadow: none; -webkit-box-shadow: none; box-shadow: none; margin-bottom: -5px; margin-top: 5px; font-weight: 500; font-style: normal; font-size: 16px; color: #FFFFFF; line-height: 40px; padding-left: 10px;}
.hotellist{width: 98%; background-color: rgba(242, 242, 242, 1);height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%; border-radius: 5px;}
.hotellist div, .hotel-info div{display: inline-block; float: left;}
.hotel-info{width: 98%; height: 80px;border: none; color: #333333;padding: 0 1%;border-bottom: 1px solid #d2cfcf; clear: both;}
.hotelImgs{display: inline-block;height: 207px;width: 33%;float: left;position: relative;top:0px;left:0px;}
.hotelImg{width:100%;height: 207px; border-radius: 4px 0px 0px 4px;}
.hotelImgs .no-room-img{bottom:45px;height:35px;line-height:35px;}
.hotelImgs .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
/* .hotellike{width: 0px;height: 25px;float: left;}
.dolike{position: relative;left: -50px;width: 35px;height: 25px;top: 15px;cursor: pointer;} */
.hotelname{font-weight: 650;font-style: normal;font-size: 16px;color: #303133;}
.hotelmess{display: inline-block;width:67%;height: 207px;position: relative;border-radius: inherit;}
.hotelMessage{margin: 0px 10px;}
.hotelMessage div{margin-top: 5px;}
.hotelmess a{text-decoration:none;}
.sold0zh{background: url(https://res.roompai.com/static/img/frame/sold-ch.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 25%;}
.sold0en{background: url(https://res.roompai.com/static/img/frame/sold-en.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 25%;}
.hoteltags{font-weight: 400;font-style: normal;color: #FCD205;}
.hotellocation{font-weight: 400;font-style: normal;font-size: 14px;color: #303133;}
.hotelselect{width:120px;height: 115px;float: right;bottom: 0;right: 0; position:absolute;}
.remain{padding:3px 5px; min-width: 59px;min-height: 20px;background: inherit;background-color: rgba(246, 228, 231, 1);font-weight: 400;font-size: 12px;color: #DC143C;text-align: center;line-height: 20px;margin-left:5px;}
.remain-empty{min-height: 20px;min-width: 65px;}
.hotelmoney{font-weight: 650;font-size: 22px;color: #E12D2D;}
.currency-text{font-weight: 400;font-size: 10px; margin-right: 5px;}
.doselect{width: 100%;height: 40px;background-color: #5392F9;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 14px;color: #FFF;line-height: 40px;text-align: center;}
.hotelpages div{display: inline-block;}
.hotelpages{margin-top: 130px; min-width: 796px;}
.hotel-totaltext{font-size: 14px;font-weight:400;color:#4F4C4C;width:346px;float: left;height: 110px;line-height: 110px;}
.hotel-totaltext span{font-weight:650;color:#d9001b;}
/deep/ .el-pager li.active, /deep/ .el-pager li:hover, /deep/ .el-pager li.active{color:rgb(241, 81, 27);}
.pageinfo{width:450px;text-align:right; float: right;}
.hotelImgs .hotel-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill: pink;}
.hotelImgs .hotel-like-1{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill:red;}
.no-hover{fill:red;}
.content-empty-text{font-size: 14px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.content-empty-img{width:200px; height:200px;}
/* 分页 */
.account-data-page{width:98%;height:70px;text-align:right;margin-top: 40px; position: relative;bottom: 0px;}
.account-data-page-list{width:98%;height:70px;text-align:right;margin-top: 40px; margin-right: 2%;}
.account-data-page .el-pagination.is-background .el-pager li,.account-data-page .el-pagination.is-background .btn-prev,.account-data-page .el-pagination.is-background .btn-next,  .account-data-page-list .el-pagination.is-background .el-pager li,.account-data-page-list .el-pagination.is-background .btn-prev,.account-data-page-list .el-pagination.is-background .btn-next{background:white; color: #333333;}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active, /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:rgba(83, 102, 163, 1); color:#FFF;}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{color:white;background-color: rgba(83, 102, 163, 0.6);}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color: white;background-color: rgba(83, 102, 163, 1);}
/* 手机版 排序 */
.sort-info div{height: 50px; line-height: 50px;font-size: 14px;text-align:center; border-top: 1px solid rgba(221, 223, 226, 1);}
</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
.listCurrency-info {
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
}
.price-list-info {
  color: #9455A1;
  font-weight: 600;
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
}
.point-info{
  margin-left: 2px;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #2F7000;
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/HotelList.vue